import { supabase } from './supabase';

export const MODALIDADES_PADRAO = [
  { value: 'nutricao-treino', label: 'Nutrição + Treino' },
  { value: 'treino', label: 'Treino' },
  { value: 'nutricao', label: 'Nutrição' },
  { value: 'bonus', label: 'Bônus' },
];

export const MODALIDADES_LEGADAS = {
  online: 'Consultoria Online (Treino + Nutrição)',
  'online-treino': 'Consultoria Online (Treino)',
  presencial: 'Treino Presencial',
};

export const LEMBRETES_AUTOMATICOS_PADRAO = [
  {
    pt: 'Já bebeu água hoje? Um copo agora já conta como cuidado.',
    en: 'Have you had water today? One glass now already counts as care.',
  },
  {
    pt: 'Não pula refeição. Um dia consistente vale mais do que um dia perfeito.',
    en: 'Do not skip meals. A consistent day is better than a perfect one.',
  },
  {
    pt: 'Passa no plano de hoje e escolhe o próximo passo simples.',
    en: 'Check today’s plan and choose the next simple step.',
  },
  {
    pt: 'Seu corpo responde melhor quando você cuida do básico: água, comida e descanso.',
    en: 'Your body responds better when you cover the basics: water, food and rest.',
  },
  {
    pt: 'Se a rotina apertou, volta para o simples: uma refeição organizada e água por perto.',
    en: 'If the day got busy, return to simple: one organized meal and water nearby.',
  },
];

export const PUSH_LEMBRETES_PADRAO = {
  ativo: false,
  hora: '09:00',
  titulo: {
    pt: 'Team Carol Macedo',
    en: 'Team Carol Macedo',
  },
  mensagens: LEMBRETES_AUTOMATICOS_PADRAO,
};

export async function carregarConfig(key, fallback) {
  try {
    const { data, error } = await supabase
      .from('app_config')
      .select('value')
      .eq('key', key)
      .maybeSingle();
    if (error) throw error;
    return data?.value ?? fallback;
  } catch {
    return fallback;
  }
}

export async function salvarConfig(key, value) {
  const { error } = await supabase
    .from('app_config')
    .upsert({ key, value, updated_at: new Date().toISOString() });
  if (error) throw error;
}

export async function appConfigDisponivel() {
  try {
    const { error } = await supabase.from('app_config').select('key').limit(1);
    return !error;
  } catch {
    return false;
  }
}

export async function carregarModalidadesContratadas() {
  const extras = await carregarConfig('modalidades_contratadas', []);
  return Array.isArray(extras) ? extras.filter(Boolean) : [];
}

export async function salvarModalidadesContratadas(modalidades) {
  return salvarConfig('modalidades_contratadas', modalidades.filter(Boolean));
}

export async function carregarLembretesAutomaticos() {
  const lembretes = await carregarConfig('lembretes_automaticos', LEMBRETES_AUTOMATICOS_PADRAO);
  return Array.isArray(lembretes) && lembretes.length > 0 ? lembretes : LEMBRETES_AUTOMATICOS_PADRAO;
}

export async function salvarLembretesAutomaticos(lembretes) {
  return salvarConfig('lembretes_automaticos', lembretes.filter(item => item?.pt || item?.en));
}

export async function carregarPushLembretes() {
  const config = await carregarConfig('push_lembretes', PUSH_LEMBRETES_PADRAO);
  return {
    ...PUSH_LEMBRETES_PADRAO,
    ...(config && typeof config === 'object' ? config : {}),
    titulo: {
      ...PUSH_LEMBRETES_PADRAO.titulo,
      ...(config?.titulo || {}),
    },
    mensagens: Array.isArray(config?.mensagens) && config.mensagens.length > 0
      ? config.mensagens
      : PUSH_LEMBRETES_PADRAO.mensagens,
  };
}

export async function salvarPushLembretes(config) {
  return salvarConfig('push_lembretes', {
    ativo: Boolean(config?.ativo),
    hora: config?.hora || PUSH_LEMBRETES_PADRAO.hora,
    titulo: {
      pt: config?.titulo?.pt || PUSH_LEMBRETES_PADRAO.titulo.pt,
      en: config?.titulo?.en || config?.titulo?.pt || PUSH_LEMBRETES_PADRAO.titulo.en,
    },
    mensagens: (config?.mensagens || []).filter(item => item?.pt || item?.en),
  });
}

export async function carregarJornadaConfig() {
  const value = await carregarConfig('feature_jornada', { ativoTodos: false, alunaIds: [] });
  return {
    ativoTodos: Boolean(value?.ativoTodos ?? value?.ativo),
    alunaIds: Array.isArray(value?.alunaIds) ? value.alunaIds.filter(Boolean) : [],
  };
}

export async function salvarJornadaConfig(config) {
  return salvarConfig('feature_jornada', {
    ativoTodos: Boolean(config?.ativoTodos),
    alunaIds: Array.isArray(config?.alunaIds) ? config.alunaIds.filter(Boolean) : [],
  });
}
